import React from 'react';
import { useParams } from 'react-router-dom';
import CaseStudyPage from '../../components/CaseStudies/CaseStudyPage';
import NotFound from '../NotFound';
import { getCaseStudyBySlug } from '../../content/case-studies';

/** Dynamic route /case-studies/:slug — renders any case study from the content registry. */
const CaseStudyPostPage = () => {
  const { slug } = useParams();
  const post = getCaseStudyBySlug(slug);

  if (!post) return <NotFound />;
  return <CaseStudyPage post={post} />;
};

export default CaseStudyPostPage;
